export enum Controllers {
  accounts = 'accounts',
  auth = 'auth',
  custodians = 'custodians',
  dealers = 'dealers',
  investors = 'investors',
  issuers = 'issuers',
  logs = 'logs',
  prices = 'prices',
  revenueStructures = 'revenue-structures',
  securities = 'securities',
  transactions = 'transactions',
  users = 'users',
}
